var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.7 59.2",
    style: {
      enableBackground: "new 0 0 46.7 59.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,0v52.8h-4.9V3.9H7.3V0H46.7z M22.2,17.9c-0.7-1.7-1.6-2.8-2.5-2.8c-0.9,0-1.7,1.1-2.5,2.8 c-0.8,2.2-1.3,4.5-1.4,6.9h7.7C23.5,22.4,23,20.1,22.2,17.9z M19.7,36.9c0.9,0,1.7-1.1,2.5-2.8c0.8-2.2,1.3-4.5,1.4-6.9h-7.7 c0.1,2.4,0.5,4.7,1.4,6.9C18,35.9,18.8,36.9,19.7,36.9z M30.6,27.2C30.6,27.2,30.6,27.2,30.6,27.2L30.6,27.2L30.6,27.2z M26,24.8 h4.6c-0.4-3.9-3-7.3-6.6-8.8c0.2,0.3,0.3,0.7,0.5,1C25.4,19.5,25.9,22.1,26,24.8z M30.6,27.2H26c-0.1,2.7-0.6,5.3-1.6,7.8 c-0.2,0.4-0.3,0.7-0.5,1C27.6,34.5,30.1,31.2,30.6,27.2z M15,17c0.2-0.4,0.3-0.7,0.5-1c-1.3,0.6-2.5,1.3-3.5,2.3 c-1.8,1.7-2.9,4-3.1,6.5h4.6C13.5,22.1,14,19.5,15,17z M0,6.3h39.4v52.8H0V6.3z M33.6,51.7c0-0.7-0.5-1.2-1.2-1.3H7 c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.3h25.4C33,52.8,33.6,52.3,33.6,51.7z M32.4,45.2h-3.7c-0.7,0-1.2,0.5-1.2,1.2 s0.5,1.2,1.2,1.2h3.7c0.7,0,1.2-0.5,1.2-1.2S33.1,45.2,32.4,45.2z M6.3,26c0,7.4,6,13.4,13.4,13.4s13.4-6,13.4-13.4 c0-7.4-6-13.4-13.4-13.4c-3.5,0-7,1.4-9.5,3.9C7.7,19.1,6.3,22.5,6.3,26z M5.8,46.4c0,0.7,0.5,1.2,1.2,1.2h15.7 c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2H7C6.3,45.2,5.8,45.8,5.8,46.4z M15.4,36.1c-0.2-0.3-0.3-0.7-0.5-1c-1-2.5-1.5-5.2-1.6-7.8 H8.8c0.3,2.5,1.4,4.8,3.1,6.5C13,34.7,14.1,35.5,15.4,36.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.e8a37df72062b45610f86260b8186ca8.svg";
export { ForwardRef as ReactComponent };